"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var tabNavigationStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  borderBottom: "1px solid " + colors_1.carrarra,
  fontSize: 16,
  width: '100%',
  height: 48,
  outline: 'none'
});
var tabNavigationItemStyle = hs_web_style_guide_1.css({
  height: 48,
  lineHeight: '24px',
  color: colors_1.silverChalice,
  padding: '8px 16px 16px 16px',
  marginRight: 16,
  ':last-of-type': {
    marginRight: 0
  },
  ':hover': {
    color: colors_1.doveGrey
  },
  outline: 'none',
  cursor: 'pointer'
});
var tabNavigationSelectedStyle = hs_web_style_guide_1.css(font_1.bold, {
  color: colors_1.jaffa,
  height: 23,
  borderBottom: "2px solid " + colors_1.jaffa,
  ':hover': {
    color: colors_1.jaffa
  }
});

function onlyOneItemSelected(links) {
  var selectedCount = links.filter(function (link) {
    return link.selected;
  }).length;
  return selectedCount === 1;
}

function TabNavigation(props) {
  var links = props.links;
  return React.createElement("div", __assign({
    tabIndex: 1,
    className: "tabNavigation"
  }, tabNavigationStyle, font_1.regular), links.map(function (item, index) {
    return React.createElement("div", __assign({
      key: index,
      tabIndex: 1,
      onClick: function onClick() {
        return onlyOneItemSelected(links) && item.selected ? null : item.action();
      },
      className: "tabNavigationItem " + (onlyOneItemSelected(links) && item.selected ? tabNavigationSelectedStyle : null) + " " + (onlyOneItemSelected(links) && item.selected ? 'tabNavigationItemSelected' : null)
    }, tabNavigationItemStyle), item.display);
  }));
}

exports.TabNavigation = TabNavigation;